import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-empty-state.css';
var getClassNameList = classNames.bind(styles);
var FullscreenCondtionalWrapper = function (_a) {
  var condition = _a.condition,
    children = _a.children;
  return condition ? React.createElement("div", {
    className: getClassNameList('uitk-empty-state-wrapper')
  }, children) : children;
};
var UitkEmptyState = function (props) {
  var className = props.className,
    fullscreen = props.fullscreen,
    children = props.children;
  var baseClassName = 'uitk-empty-state';
  var wrapperClassNames = getClassNameList(baseClassName, 'uitk-type-center', className);
  var newChildren;
  var hasChildren = !!React.Children.toArray(children).length;
  if (hasChildren) {
    newChildren = React.Children.map(children, function (child) {
      if (!React.isValidElement(child)) {
        return;
      }
      var existingClassName = child.props.className;
      switch (child.type.displayName) {
        case 'UitkIcon':
          return React.cloneElement(child, {
            className: getClassNameList(existingClassName, "".concat(baseClassName, "-icon"))
          });
        case 'UitkHeading':
          return React.createElement('div', {
            className: "".concat(baseClassName, "-heading")
          }, child);
        case 'UitkText':
          return React.cloneElement(child, {
            className: getClassNameList(existingClassName, "".concat(baseClassName, "-body"))
          });
        case 'UitkEmptyStateActionArea':
          return child;
        default:
          return child;
      }
    });
  }
  return React.createElement(FullscreenCondtionalWrapper, {
    condition: fullscreen
  }, React.createElement("div", {
    className: wrapperClassNames
  }, newChildren));
};
UitkEmptyState.displayName = 'UitkEmptyState';
export { UitkEmptyState };